import type { RouteRecordRaw } from "vue-router";

export const routes: RouteRecordRaw[] = [
  {
    path: "/federaties",
    name: "federations.index",
    component: () => import("@/modules/federations/views/IndexView.vue"),
    meta: {
      requiresAuth: true,
    },
  },
];
